module.exports = __webpack_public_path__ + "static/media/logos_mobile.fe5b783c.png";